import Vue from 'vue';

export default {
    async getUnreadNotificationCount() {
        const response = await Vue.axios.get('/account/notifications', {
            headers: {Authorization: `Bearer ${Vue.store.state.auth.token}`},
        }).catch((e) => {
            throw e;
        });
        return response.data.meta.unread_notifications;
    },
    async getNotifications(page) {
        console.log('loading notifications for page: ', page);
        const response = await Vue.axios.get('/account/notifications', {
            headers: {Authorization: `Bearer ${Vue.store.state.auth.token}`},
            params: { page }
        }).catch((e) => {
            throw e;
        });
        return response.data;
    },
    async getNotification(id) {
        const response = await Vue.axios.get(`/account/notifications/${id}`, {
            headers: {Authorization: `Bearer ${Vue.store.state.auth.token}`},
        });
        return response.data.data;
    },
    async deleteNotification(id) {
        const response = await Vue.axios.delete(
            `/account/notifications/${id}`,
            {headers: {Authorization: `Bearer ${Vue.store.state.auth.token}`}},
        ).catch((e) => {
            throw e;
        });
        return response.data.data;
    },
};
